import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import axios from "axios";
import "../styles/MemberLogin.css";
import { useNavigate, useLocation } from "react-router-dom";

const getRemainingTime = () => {
  const expiry = localStorage.getItem("otpExpiry");

  if (!expiry) return 0;

  const expiryTime = new Date(expiry).getTime();
  const now = Date.now();

  const remaining = Math.floor((expiryTime - now) / 1000);

  return remaining > 0 ? remaining : 0;
};

const MmeberOtpLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();     
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [resendLoading, setResendLoading] = useState(false);
  const [isOtpExpired, setIsOtpExpired] = useState(false);
  const userEmail = location.state?.email || "";

  // Get OTP expiry timestamp from localStorage
  const expiryTime = Number(localStorage.getItem("otpExpiry"));
  const remaining = Math.floor((expiryTime - Date.now()) / 1000);
  
  const [timer, setTimer] = useState(remaining > 0 ? remaining : 0);


  useEffect(() => {
    // Don't start timer if already expired
    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsOtpExpired(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Cleanup old interval before creating a new one
    return () => clearInterval(interval);
  }, [timer]);

  // 🔹 Update OTP digit
  const handleOtpChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next field automatically
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  // 🔹 Combine OTP digits into single string
  const otpValue = otp.join("");

  // 🔹 Resend OTP function
  const handleResendOtp = async () => {
    if (timer > 0 && !isOtpExpired) return;
    
    setResendLoading(true);
    setErrorMessage("");
    
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_ROLE}/resend-otp`, {
        email: userEmail
      });
      
      if (res.data.success) {
        const expiryTimestamp = new Date(res.data.signin_otp_expiry).getTime();
        localStorage.setItem("otpExpiry", expiryTimestamp);

        const remaining = Math.max(
          Math.floor((expiryTimestamp - Date.now()) / 1000),
          0
        );
        setTimer(remaining);
        setIsOtpExpired(false);
        setOtp(["", "", "", "", "", ""]); // Clear OTP fields
        // Clear any previous error messages first
        setErrorMessage("");
        // Show success message briefly
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
        // Focus on first OTP field
        setTimeout(() => {
          const firstInput = document.getElementById(`otp-0`);
          if (firstInput) firstInput.focus();
        }, 100);
      } else {
        setErrorMessage(res.data.message || "Failed to resend OTP.");
      }
    } catch (error) {
      console.error("Resend OTP failed:", error);
      setErrorMessage(
        error.response?.data?.message || "Failed to resend OTP. Please try again."
      );
      // If there's a retryAfter in response, set timer
      if (error.response?.data?.retryAfter) {
        setTimer(error.response.data.retryAfter);
      }
    } finally {
      setResendLoading(false);
    }
  };

const handleKeyDown = (e, index) => {
  if (e.key === "Backspace") {
    if (otp[index]) {
      // Clear current digit if it’s not empty
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    } else if (index > 0) {
      // Move focus to previous input if current is already empty
      document.getElementById(`otp-${index - 1}`).focus();
      const newOtp = [...otp];
      newOtp[index - 1] = "";
      setOtp(newOtp);
    }
  } else if (e.key === "ArrowLeft" && index > 0) {
    document.getElementById(`otp-${index - 1}`).focus();
  } else if (e.key === "ArrowRight" && index < 5) {
    document.getElementById(`otp-${index + 1}`).focus();
  } else if (e.key === "Enter") {
    handleSignin(); // optional: handle Enter inside OTP boxes
  }
};


  // 🔹 Submit OTP verification request
  const handleSignin = async () => {
    setErrorMessage("");

    if (isOtpExpired) {
      setErrorMessage("OTP has expired. Please request a new one.");
      return;
    }

    if (otpValue.length !== 6) {
      setErrorMessage("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_ROLE}/verify-login-otp`, {
        otp: otpValue,
        email: userEmail
      });
      console.log("reas-----------0",res.data);        
      
      if (res.data.success) {
        if (res.data.token) {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("user", JSON.stringify(res.data.user));
          localStorage.removeItem("otpExpiry");

          if (res.data.user && (res.data.user.rolename === "admin" || res.data.user.isAdmin)) {
            const adminurl = process.env.REACT_APP_API_ADMIN;
            console.log("admin  URL:", adminurl);
            const userParam = encodeURIComponent(JSON.stringify(res.data.user));
            window.location.href = `${process.env.REACT_APP_API_ADMIN}/dashboard?token=${res.data.token}&user=${userParam}`;
          } else if (res.data.user && res.data.user.rolename === "EDCC") {
            navigate("/", {
              state: { user: res.data.user, token: res.data.token },
            });
          } else if (res.data.user && res.data.user.rolename === "AssociateMember") {
            navigate("/", {
              state: { user: res.data.user, token: res.data.token },
            });
          } else if (res.data.user && res.data.user.rolename === "LifeMember") {
            navigate("/", {
              state: { user: res.data.user, token: res.data.token },
            });
          } else {
            navigate("/");
          }
        }
        navigate("/");
      } else {
        setErrorMessage(res.data.message || "Invalid OTP, please try again.");
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
      setErrorMessage(
        error.response?.data?.message || "Server error, please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="member-login-section">
        <Container>
          <div className="login-box">
            <Row>
              {/* Left Side */}
              <Col md={6} className="login-left mb-4 mb-md-0">
                <div className="login-form-container">
                  <h4 className="login-title">
                    Member Login <span className="dropdown-arrow">↓</span>
                  </h4>
                </div>
              </Col>

              {/* Right Side (OTP Form) */}
              <Col md={6}>
                {/* Timer Display */}
                {timer > 0 ? (
                  <div className="text-center mb-3">
                    <div className="timer-text">
                      OTP expires in: {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}
                    </div>
                  </div>
                ) : (
                  <div className="text-center mb-3">
                    <div className="timer-text expired">
                      OTP has expired
                    </div>
                  </div>
                )}
                
                <Form onSubmit={(e) => { e.preventDefault(); handleSignin(); }}>
                  <Form.Group className="mb-3">
                    <Form.Label className="form-label">Enter OTP</Form.Label>
                    <div className="d-flex gap-2">
                      {[0, 1, 2, 3, 4, 5].map((index) => (
                      <Form.Control
                        key={index}
                        id={`otp-${index}`}
                        type="text"
                        maxLength="1"
                        value={otp[index]}
                        onChange={(e) => handleOtpChange(e.target.value, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)} 
                        className="edcc-otp-digit text-center"
                        disabled={isOtpExpired}
                      />
                      ))}
                    </div>
                  </Form.Group>

                  {errorMessage && (
                    <div className="text-danger mb-2">
                      {errorMessage}
                    </div>
                  )}

                  <div className="mb-3">
                    <span
                      className={`resend-link ${((timer > 0 && !isOtpExpired) || resendLoading) ? "disabled" : ""}`}
                      onClick={handleResendOtp}
                    >
                      {resendLoading ? "Sending..." : "Resend OTP"}
                    </span>
                  </div>

                  <div className="text-center mb-2">
                  <Button
                    className="custom-btn w-100"
                    type="submit"
                    disabled={loading || isOtpExpired}
                  >
                    {loading ? "Verifying..." : "SIGN IN"}
                  </Button>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default MmeberOtpLogin;